'use strict';
import get from 'lodash/get';
import isFunction from 'lodash/isFunction';
import React, {Component} from 'react';
import * as T from 'prop-types';

/**
 * Requires implementation of the following methods:
 * isDirty
 * TODO: isValid
 * serializeModel
 * render
 *
 * You must include the following in the render function.
 * <View
 *   {...this.getRenderProps()}
 * </View>
 */
export class AbstractFormComponent extends Component {
  static propTypes = {
    className: T.string,
    fieldClass: T.string,
    isEditing: T.bool,
    isSaving: T.bool,

    onSave: T.func,
    onCancel: T.func,
    onEnterEdit: T.func,
    onExitEdit: T.func,
  };

  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isEditing !== nextProps.isEditing) {
      if (nextProps.isEditing && isFunction(nextProps.onEnterEdit)) {
        setTimeout(() => nextProps.onEnterEdit(), 0);

      } else if (!nextProps.isEditing && isFunction(nextProps.onExitEdit)) {
        setTimeout(() => nextProps.onExitEdit(), 0);

      }
    }
  }

  /**
   * @param event
   * @param {String} valueProp - The name of the profile property to change
   * @param {String} toggleProp - The name of the state property indicating change is in progress
   * @param {String} [errorProp] - The name of the state property for the validation error message
   * @protected
   */
  handleValueChange(event, valueProp, toggleProp, errorProp) {
    const prevValue = get(this.props.model, valueProp, '');
    const nextValue = event.target.value;
    const isToggled = prevValue !== nextValue;
    const nextState = {
      [valueProp]: isToggled ? nextValue : prevValue,
      [toggleProp]: isToggled,
    };

    if (errorProp) {
      nextState[errorProp] = !event.target.isValid;
    }

    this.setState(nextState);

    // TODO: report change to onChange prop, if any
  }

  /**
   * @param event
   * @param {String} errorProp - The name of the state property for the validation error message
   * @protected
   */
  handleValidationChange(event, errorProp) {
    if (errorProp) {
      const nextState = {
        [errorProp]: !event.target.isValid,
      };

      this.setState(nextState);
    }

    // TODO: report change to onValidationChange prop, if whole form has changed: prev.valid !== next.valid
  }

  /**
   * @param event
   * @private
   */
  handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();
    if (!isFunction(this.props.onSave))
      return;

    this.save();
  }

  getRenderProps() {
    return {
      className: this.props.className,
      fieldClass: this.props.fieldClass,
      isEditing: this.props.isEditing,
      isSaving: this.props.isSaving,

      onSave: this.props.onSave,
      onCancel: this.props.onCancel,
      onEnterEdit: this.props.onEnterEdit,
      onExitEdit: this.props.onExitEdit,
      onSubmit: this.handleSubmit,
    };
  }

  /**
   * Call props.onSave with the modified model data.
   */
  save() {
    if (this.isDirty()) {
      if (isFunction(this.props.onSave)) {
        this.props.onSave(this.serializeModel());
      }
    } else {
      if (isFunction(this.props.onCancel)) {
        this.props.onCancel();
      }
    }
  }

  /**
   * @abstract
   */
  serializeModel() {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/js/components/forms/AbstractForm/AbstractFormComponent.js